import { LuCheck } from 'react-icons/lu'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { courseOne, courseTwo, herbalWalkPortrait } from '@/assets/siteMedia'

const journey = [
  { year: '1980s', label: 'Jamaica', detail: 'Introduced to plant medicine by her grandmother' },
  {
    year: '2008',
    label: 'Westminster',
    detail: 'BSc (Hons) Medical Herbalism with 500 hours of supervised practice',
  },
  {
    year: '2004+',
    label: 'Clinical Practice',
    detail: '30+ years of holistic health experience across UK & Jamaica',
  },
  {
    year: 'Global',
    label: 'Africa & Caribbean',
    detail: 'Studies with traditional healers in Gambia, Togo & Burkina Faso',
  },
  {
    year: 'Now',
    label: 'Instrumental Health',
    detail: 'Consultations, courses, products, and public speaking',
  },
]

const recognitions = [
  { label: "Unsung Women's Award", sub: 'Haringey Borough' },
  { label: 'I See You Documentary', sub: 'Co-creator & Co-producer' },
  { label: 'Dogon Kemetic School', sub: 'Official UK Representative' },
  { label: 'Medicine Festival', sub: 'Speaker & Educator' },
]

export const AboutJourney = () => (
  <section className="overflow-hidden border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader title="Rooted in nature," accent="trained in science" />

      <div className="grid items-start gap-10 lg:grid-cols-[260px_1fr_280px] lg:gap-12">
        <Reveal>
          <img
            src={courseTwo}
            alt="Kandake sharing herbal health knowledge"
            className="mb-4 aspect-[3/4] w-full rounded-2xl object-cover"
            loading="lazy"
          />
          <img
            src={herbalWalkPortrait}
            alt="Kandake teaching about plants in nature"
            className="aspect-[4/3] w-full rounded-2xl object-cover"
            loading="lazy"
          />
        </Reveal>

        <ol>
          {journey.map((step, i) => (
            <li key={step.year}>
              <Reveal delay={i * 80}>
                <div className={`relative flex gap-6 ${i < journey.length - 1 ? 'pb-8' : ''}`}>
                  <div className="flex w-14 shrink-0 flex-col items-center">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-green-200 bg-white">
                      <div className="h-2.5 w-2.5 rounded-full bg-green-700" />
                    </div>
                    {i < journey.length - 1 && (
                      <div className="mt-2 w-px flex-1 bg-gradient-to-b from-green-200 to-base-200" />
                    )}
                  </div>
                  <div className="pb-2 pt-1">
                    <div className="mb-1 flex items-baseline gap-3">
                      <span className="font-display text-sm text-gold-500">{step.year}</span>
                      <h3 className="font-display text-xl text-base-900">{step.label}</h3>
                    </div>
                    <p className="text-sm leading-6 text-base-600">{step.detail}</p>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>

        <Reveal delay={200}>
          <h3 className="mb-5 font-display text-xl text-base-900">
            Recognitions &amp; affiliations
          </h3>
          <ul className="mb-6 space-y-3">
            {recognitions.map((r) => (
              <li
                key={r.label}
                className="flex items-start gap-3.5 rounded-2xl border border-base-200 bg-base-50 p-4 transition-colors hover:border-green-300"
              >
                <span
                  aria-hidden="true"
                  className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-700"
                >
                  <LuCheck className="h-3.5 w-3.5" />
                </span>
                <div>
                  <p className="text-sm font-medium text-base-800">{r.label}</p>
                  <p className="text-sm text-base-500">{r.sub}</p>
                </div>
              </li>
            ))}
          </ul>
          <img
            src={courseOne}
            alt="Kandake speaking at a community event"
            className="aspect-[4/3] w-full rounded-2xl object-cover"
            loading="lazy"
          />
        </Reveal>
      </div>
    </div>
  </section>
)
